import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  navType: 'uat',
  BACKEND_API_BASE_URL: 'https://api.stoltuat.com/st-aeye-backend-uat',
  AAD_CLIENT_ID: "15632a61-f2db-4dd4-ad41-6f634f64a207",
  AAD_AUTHORITY: "https://login.microsoftonline.com/35d14ae1-4ee5-441b-a84a-6791dee05c7b",
  AAD_REDIRECT_URI: "https://aeye-uat.stolttankers.com",
  AAD_GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  AAD_USER_API_SCOPE: 'api://ad5e44de-b42d-4be0-afaa-ff4d5c54e50f/.default',
  POSTHOG_API_KEY:'phc_u47UkcnXr5j39dsCUKibxpkejSLrBHD53FKciceTvwLE',
  POSTHOG_API_HOST:'https://ph.stolt.com',
  POSTHOG_API_DEFAULTS: '2026-06-08',
  POSTHOG_ENABLED_TRACKING:true,
  POSTHOG_UI_HOST: 'https://ph.stolt.com'
};
